import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useTimer } from "use-timer";
import cn from "classnames";
import PillContainer from "./PillContainer";
import { HiPause, HiPlay } from "react-icons/hi2";
import Button from "@components/button/Button";
import { Tag } from "@components/tag/Tag";
import AnimateHeight from "react-animate-height";
import useTranslations from "@hooks/useTranslations";
const TrendingTopics = ({ data }) => {
    var _a, _b, _c;
    if (!data || !data.tabs) {
        return null;
    }
    const { t } = useTranslations();
    const [activeTab, setActiveTab] = useState((_a = data.tabs[0]) === null || _a === void 0 ? void 0 : _a.title);
    const [isPaused, setIsPaused] = useState(false);
    const [tabContent, setTabContent] = useState(data.tabs[0]);
    const [selectedInsightIndex, setSelectedInsightIndex] = useState(0);
    const [progressBarStyle, setProgressBarStyle] = useState();
    const restartTimer = () => {
        reset();
        if (!isPaused) {
            start();
        }
    };
    const { start, pause, reset } = useTimer({
        autostart: true,
        initialTime: 0,
        interval: 500,
        onTimeUpdate: (seq) => {
            //6.5seconds for animation
            if (seq === 13) {
                setSelectedInsightIndex(selectedInsightIndex === tabContent.items.length - 1 ? 0 : selectedInsightIndex + 1);
                restartTimer();
            }
        }
    });
    useEffect(() => {
        if (activeTab) {
            setTabContent(data.tabs.find((tab) => tab.title === activeTab));
            setSelectedInsightIndex(0);
            restartTimer();
        }
    }, [activeTab]);
    useEffect(() => {
        setProgressBarStyle({ animationPlayState: isPaused ? "paused" : "running" });
        isPaused ? pause() : start();
    }, [isPaused]);
    return (_jsxs("div", { className: "trending-topics", children: [_jsx("h2", { className: "trending-topics__heading", children: data.heading }), _jsx(PillContainer, { active: activeTab, setActiveTab: setActiveTab, items: data.tabs.map((tab) => tab.title) }), _jsxs("div", { className: "trending-topics__content container", children: [tabContent && ((_b = tabContent.items) === null || _b === void 0 ? void 0 : _b.length) > 0 && (_jsx("div", { className: "trending-topics__actions-container", children: isPaused ? (_jsx(HiPlay, { onClick: () => {
                                setIsPaused(!isPaused);
                            } })) : (_jsx(HiPause, { onClick: () => {
                                setIsPaused(!isPaused);
                            } })) })), tabContent && ((_c = tabContent.items) === null || _c === void 0 ? void 0 : _c.length) > 0 && (_jsx("div", { className: "trending-topics__left-container", children: tabContent.items.map((item, index) => (_jsxs("div", { className: cn("trending-topics__insight-container", index === selectedInsightIndex && "trending-topics__insight-container--active"), children: [_jsx("div", { className: "insight-progress-bar", style: progressBarStyle }), _jsxs("div", { className: "trending-topics__insight-item", children: [_jsxs("button", { className: "trending-topics__insight-item-btn", onClick: () => {
                                                setSelectedInsightIndex(index);
                                                restartTimer();
                                            }, children: [item.tag && _jsx(Tag, { label: item.tag }), _jsx("h5", { className: "trending-topics__insight-item-title", children: item.title })] }), _jsxs(AnimateHeight, { className: "trending-topics__insight-animated-panel", duration: 500, height: index === selectedInsightIndex ? "auto" : 0, children: [_jsx("p", { className: "trending-topics__insight-description", children: item.description }), item.readMoreLink && _jsx(Button, { className: "trending-topics__insight-more", type: "tertiary", link: item.readMoreLink, title: t("BDO.LiveSite.ReadMore") })] })] }, item.title + index)] }, item.title + index))) })), _jsxs("div", { className: "trending-topics__right-container", children: [tabContent && tabContent.imageURL && tabContent.imageAltText && (_jsx("div", { className: "trending-topics__topic-image-wrapper", children: _jsx("img", { className: "trending-topics__topic-image", src: tabContent.imageURL, alt: tabContent.imageAltText }) })), tabContent && tabContent.readMoreLink && (_jsx(Button, { className: "trending-topics__topic-more", type: "tertiary", link: tabContent.readMoreLink, title: t("BDO.LiveSite.LearnMore") }))] })] })] }));
};
export default TrendingTopics;
